'use strict';

require('./directives/rorymadden.date-dropdowns');
require('./directives/cp.redactor');
require('./directives/ui-select-manual-clear');

require('./services/utils.service');
require('./services/autocomplete.service');
require('./services/softdeleteable.service');
require('./services/hideshowpassword.service');
require('./services/fileUploadFilters.service');
require('./services/http.service');

// Fields
require('./models/fields/Text');
require('./models/fields/Select');
require('./models/fields/SelectObject');
require('./models/fields/Collection');
require('./models/fields/DateDropdowns');
require('./models/fields/Checkbox');
require('./models/fields/CheckboxCollection');
require('./models/fields/FileUpload');
require('./models/fields/ImageUpload');
require('./models/fields/MountainAreaSelect');
require('./models/fields/MountainPeakSelect');
require('./models/fields/UserSelect');
require('./models/fields/Hidden');
require('./models/fields/Slider');
require('./models/fields/Range');
require('./models/fields/RadioCollection');
require('./models/fields/Number');
require('./models/fields/Textarea');
require('./models/fields/UiSelect');
require('./models/fields/UiDatepicker');
require('./models/fields/UiTypeahead');
require('./models/fields/Url');

// Validators
require('./validators/collectionMinlength');
require('./validators/collectionMaxlength');
require('./validators/numericOnly');
require('./validators/emailOnly');
require('./validators/urlOnly');

// Themes
require('./themes/bootstrap/bootstrap');
require('./themes/far/far');

angular.module('dekky.forms', [
	'rorymadden.date-dropdowns',
	'cp.redactor',
	'dekky.forms.uiSelect',
	'dekky.forms.utils',
	'dekky.forms.autocomplete',
	'dekky.forms.softdeleteable',
	'dekky.forms.hideShowPassword',
	'dekky.forms.fileUploadFilters',
	'dekky.forms.http',

	'dekky.forms.fields.text',
	'dekky.forms.fields.select',
	'dekky.forms.fields.selectObject',
	'dekky.forms.fields.collection',
	'dekky.forms.fields.dateDropdowns',
	'dekky.forms.fields.checkbox',
	'dekky.forms.fields.checkboxCollection',
	'dekky.forms.fields.fileUpload',
	'dekky.forms.fields.imageUpload',
	'dekky.forms.fields.mountainAreaSelect',
	'dekky.forms.fields.mountainPeakSelect',
	'dekky.forms.fields.userSelect',
	'dekky.forms.fields.hidden',
	'dekky.forms.fields.slider',
	'dekky.forms.fields.range',
	'dekky.forms.fields.radioCollection',
	'dekky.forms.fields.number',
	'dekky.forms.fields.textarea',
	'dekky.forms.fields.uiSelect',
	'dekky.forms.fields.uiDatepicker',
	'dekky.forms.fields.uiTypeahead',
	'dekky.forms.fields.url',

	//'dekky.forms.validators.collectionMinlength',
	'dekky.forms.validators.collectionMaxlength',
	'dekky.forms.validators.numericOnly',
	'dekky.forms.validators.emailOnly',
	'dekky.forms.validators.urlOnly',

	'dekky.forms.themes.bootstrap',
	'dekky.forms.themes.far'
])
.value('formsConfig', {
	theme: '/dekky.forms/themes/bootstrap'
});
